import { blackColors, whiteColor } from 'assets/jss/material-dashboard-pro-react';

const detailsStyle = (theme) => ({
	cell: {
		margin: 0,
	},
	maxReached: {
		marginTop: 134,
	},
	selectAccessContainer: {
		margin: '10px 0',
		width: '100%',
	},
	accountIcon: { display: 'flex', justifyContent: 'flex-end' },
	accountDatePicker: {
		[theme.breakpoints.down('sm')]: {
			width: '75%',
		},
		width: '100%',
	},
	unlimitedWithLabel: {
		position: 'relative',
		top: -4,
	},
	editTypeDialogContainer: {
		padding: '24px 120px',
		[theme.breakpoints.down('sm')]: {
			paddingLeft: 10,
			paddingRight: 10,
		},
	},
	calendar: {
		'& .rdtPicker': {
			right: 0,
		},
	},
	userInformationHeader: {
		marginTop: 24,
	},
	unlimitedCheckboxContainer: {
		position: 'relative',
		top: 2,
	},
	unlimitedCheckboxChecked: {
		'& svg': {
			width: 16,
			height: 16,
		},
	},
	unlimitedCheckboxUnchecked: {
		'& svg': {
			padding: 7,
		},
	},
	departmentBadges: {
		overflow: 'scroll',
		height: 130,
	},
	alignRight: {
		textAlign: 'right',
	},
	permissionCellHeader: {
		marginTop: 28,
	},
	permissionContainer: {
		display: 'flex',
	},
	billingAccountPermissionContainer: {
		display: 'flex',
		alignItems: 'center',
	},
	billingAccountDeletePermission: {
		marginLeft: '10px',
	},
	permissionCellAccess: {
		width: '50%',
		display: 'inline-block',
	},
	noPermissions: {
		marginTop: 24,
	},
	calendarValue: {
		marginTop: -7,
	},
	permissionCell: {
		width: '45%',
		display: 'inline-block',
	},
	permissionCloseCell: {
		width: '10%',
		display: 'inline-block',
	},
	fullWidthForXs: {
		[theme.breakpoints.down('xs')]: {
			width: '100%',
		},
	},
	left: {
		textAlign: 'left',
	},
	departmentBadgeContainer: {
		[theme.breakpoints.up('sm')]: {
			marginTop: 8,
		},
	},
	departmentBadge: {
		padding: '4px 8px',
		cursor: 'pointer',
		display: 'inline-block',
		marginBottom: 8,
		marginRight: 4,
		borderRadius: 16,
		whiteSpace: 'nowrap',
	},
	departmentPermissionDivider: {
		[theme.breakpoints.down('xs')]: {
			width: '66%',
			margin: 'auto',
			height: 1,
			backgroundColor: blackColors[6],
			display: 'block',
			marginBottom: 20,
		},
		display: 'none',
	},
	departmentHeader: {
		marginTop: 30,
	},
	departmentBadgeIcon: {
		color: whiteColor,
		width: 16,
		height: 16,
		marginLeft: 2,
		position: 'relative',
		top: 3,
	},
	maxAmount: {
		paddingTop: 90,
	},
	dialogBody: {
		padding: '24px 56px 50px',
		minHeight: 440,
		[theme.breakpoints.down('sm')]: {
			paddingLeft: 10,
			paddingRight: 10,
			paddingBottom: 180,
		},
	},
	iconCardBody: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		'& > svg': {
			width: 56,
			height: 56,
			color: blackColors[4],
		},
	},
	email: {
		marginTop: 4,
		marginBottom: 0,
	},
	badge: {
		position: 'relative',
		top: -3,
		left: 12,
	},
	iconCard: {
		width: '100%',
		height: 'calc(100% - 32px)',
		[theme.breakpoints.down('md')]: {
			maxWidth: 112,
			marginLeft: 'auto',
			marginRight: 'auto',
		},
	},
	center: {
		textAlign: 'center',
	},
	emptyElementsContainer: {
		paddingTop: 48,
		paddingBottom: 60,
		textAlign: 'center',
	},
	editButton: {
		position: 'absolute',
		top: 0,
		right: 20,
		[theme.breakpoints.down('sm')]: {
			position: 'static',
		},
	},
	infoCardGrid: {
		[theme.breakpoints.down('sm')]: {
			marginBottom: 55,
		},
	},
	permissionsHeader: {
		marginTop: 95,
		position: 'relative',
		'& > div': {
			position: 'absolute',
			top: -15,
			right: 0,
		},
	},
	departmentsContent: {
		margin: '0 12px',
		width: 'calc(100% - 24px)',
	},
	userInformationWrapper: {
		'& > div > div > div': {
			// card body
			paddingTop: '33px',
		},
	},
	inlineIcon: {
		height: 16,
		width: 16,
		objectFit: 'cover',
		marginRight: 8,
	},
	permissionAccountInfo: {
		marginBottom: 20,
	},
	contactNumber: {
		paddingTop: 4,
	},
	dialogBodyWrapper: {
		margin: '72px',
	},
});

export default detailsStyle;
